export default {
  name: "SvgFiller",
  render(c) {
    return c(
      "svg",
      {
        style: { "vertical-align": "middle" },
        attrs: {
          viewBox: this.viewBox,
          width: this.width,
          height: this.height,
          fill: this.fillColor,
          stroke: this.strokeColor
        },
        on: {
          mouseover: () => this.mouseHoverEvent("over"),
          mouseleave: () => this.mouseHoverEvent("leave"),
          click: (event) => this.$emit("click", event)
        }
      },
      this.dataOfPaths.map((dataOfPath, index) => {
        const pathAttrs = { d: dataOfPath };
        // Preserve stroke-width and other attributes from original SVG
        if (this.pathAttributes[index]) {
          Object.assign(pathAttrs, this.pathAttributes[index]);
        }
        return c("path", { attrs: pathAttrs });
      })
    );
  },
  props: {
    path: {
      type: String,
      required: true
    },
    fill: {
      type: String,
      default: "#000"
    },
    width: {
      type: String,
      default: "24px"
    },
    height: {
      type: String,
      default: "24px"
    },
    hoverColor: {
      type: String
    },
    stroke: {
      type: String,
      default: "none"
    },
    hoverStrokeColor: {
      type: String
    }
  },
  data() {
    return {
      viewBox: "0 0 24 24",
      dataOfPaths: [],
      pathAttributes: [],
      fillColor: "#000",
      strokeColor: "none"
    };
  },
  mounted() {
    this.createSvgElement();
  },
  watch: {
    fill(val) {
      this.updateFillColor(val);
    },
    stroke(val) {
      this.updateStrokeColor(val);
    },
    path() {
      this.createSvgElement();
    }
  },
  methods: {
    createSvgElement() {
      // Clear existing paths to prevent accumulation
      this.dataOfPaths = [];
      this.pathAttributes = [];

      const dir = window.location.origin;
      const source = this.path.match(/^http(s?):\/\//)
        ? this.path
        : this.path.substring(0, 1) === "/"
        ? `${dir}${this.path}`
        : `${dir}/${this.path}`;

      // Store the current path prop to prevent race conditions
      const currentPath = this.path;
      const request = new XMLHttpRequest();
      request.open("GET", source, true);
      request.onload = () => {
        // Only process if this is still the current path (prevent race conditions)
        if (this.path !== currentPath) {
          return;
        }

        if (request.status >= 200 && request.status < 400) {
          // Clear paths again right before processing to ensure clean state
          this.dataOfPaths = [];
          this.pathAttributes = [];

          const domParser = new DOMParser();
          const elementSvg = domParser.parseFromString(request.responseText, "text/xml");
          const tagSvg = elementSvg.getElementsByTagName("svg")[0];
          [...elementSvg.getElementsByTagName("path")].forEach((pathOfSvg) => {
            this.viewBox = tagSvg.getAttribute("viewBox");
            this.updateSrcSvgElement(pathOfSvg.getAttribute("d"));
            // Extract and preserve stroke-width and other important attributes
            const pathAttrs = {};
            const strokeWidth = pathOfSvg.getAttribute("stroke-width");
            if (strokeWidth) {
              pathAttrs["stroke-width"] = strokeWidth;
            }
            const strokeLinecap = pathOfSvg.getAttribute("stroke-linecap");
            if (strokeLinecap) {
              pathAttrs["stroke-linecap"] = strokeLinecap;
            }
            const strokeLinejoin = pathOfSvg.getAttribute("stroke-linejoin");
            if (strokeLinejoin) {
              pathAttrs["stroke-linejoin"] = strokeLinejoin;
            }
            this.pathAttributes.push(pathAttrs);
            this.updateFillColor(this.fill);
            this.updateStrokeColor(this.stroke);
          });
        } else {
          this._errorLog(`Can't load element from this path.\nPath : ${source}`);
        }
      };
      request.onerror = () => {
        this._errorLog(`Can't load element from this path.\nPath : ${source}`);
      };
      request.send();
    },
    updateSrcSvgElement(val) {
      if (val === undefined) {
        this._errorLog(`Can't get attribute 'd' from your SVG file.`);
        return;
      }
      this.dataOfPaths.push(val);
    },
    updateFillColor(val) {
      this.fillColor = val;
    },
    updateStrokeColor(val) {
      this.strokeColor = val;
    },
    mouseHoverEvent(event) {
      if (event === "over") {
        if (this.hoverColor) this.updateFillColor(this.hoverColor);
        if (this.hoverStrokeColor) this.updateStrokeColor(this.hoverStrokeColor);
      } else {
        if (this.hoverColor) this.updateFillColor(this.fill);
        if (this.hoverStrokeColor) this.updateStrokeColor(this.stroke);
      }
    },
    _errorLog(log) {
      console.error(`[ERROR] : vue-svg-filler, ${log}`);
    }
  }
};
